function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#f8f8f8",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 23.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 22
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.049 33.189h-5.187V16.498h5.187zm-2.6-18.968a3.016 3.016 0 113-3.032 3.027 3.027 0 01-3 3.032zm22 18.968h-5.173v-8.125c0-1.936-.039-4.42-2.7-4.42-2.7 0-3.108 2.1-3.108 4.28v8.265h-5.174V16.498h4.972v2.277h.073a5.447 5.447 0 014.905-2.7c5.246 0 6.211 3.454 6.211 7.941v9.173h-.006z",
  fill: "#f8f8f8"
});

function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NyIgaGVpZ2h0PSI0NyIgdmlld0JveD0iMCAwIDQ3IDQ3Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI5MCAtNDM5MSkiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyOTAgNDM5MSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2Y4ZjhmOCIgc3Ryb2tlLXdpZHRoPSIzIj48Y2lyY2xlIGN4PSIyMy41IiBjeT0iMjMuNSIgcj0iMjMuNSIgc3Ryb2tlPSJub25lIi8+PGNpcmNsZSBjeD0iMjMuNSIgY3k9IjIzLjUiIHI9IjIyIiBmaWxsPSJub25lIi8+PC9nPjxwYXRoIGQ9Ik01LjYsMjVILjQxM1Y4LjMwOUg1LjZaTTMsNi4wMzJBMy4wMTYsMy4wMTYsMCwxLDEsNiwzLDMuMDI3LDMuMDI3LDAsMCwxLDMsNi4wMzJaTTI1LDI1SDE5LjgyN1YxNi44NzVjMC0xLjkzNi0uMDM5LTQuNDItMi43LTQuNDItMi43LDAtMy4xMDgsMi4xLTMuMTA4LDQuMjhWMjVIOC44NDVWOC4zMDloNC45NzJ2Mi4yNzdoLjA3M2E1LjQ0Nyw1LjQ0NywwLDAsMSw0LjkwNS0yLjdjNS4yNDYsMCw2LjIxMSwzLjQ1NCw2LjIxMSw3Ljk0MVYyNUgyNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMDEuNDQ5IDQzOTkuMTg5KSIgZmlsbD0iI2Y4ZjhmOCIvPjwvZz48L3N2Zz4=";
export { SvgLinkedIn as ReactComponent };